import { useState } from 'react';
import { Copy, Link2, RefreshCw } from 'lucide-react';
import { ApiError } from '@/lib/api';
import { copyInviteLink, getInviteUrl } from '@/lib/invite';
import { Button } from '@/components/ui';

interface InviteLinkBoxProps {
  inviteCode: string;
  label?: string;
  onRegenerate?: () => Promise<string>;
}

export function InviteLinkBox({ inviteCode, label = 'Davet Linki', onRegenerate }: InviteLinkBoxProps) {
  const [code, setCode] = useState(inviteCode);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleCopy() {
    const ok = await copyInviteLink(code);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  async function handleRegenerate() {
    if (!onRegenerate) return;
    setLoading(true);
    setError('');
    try {
      const newCode = await onRegenerate();
      setCode(newCode);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Link yenilenemedi');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="rounded-xl border border-border bg-white/60 p-3">
      <div className="mb-2 flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-primary">{label}</p>
        <div className="flex gap-1">
          {onRegenerate && (
            <Button type="button" size="sm" variant="outline" onClick={handleRegenerate} disabled={loading}>
              <RefreshCw className="h-3 w-3" />
            </Button>
          )}
          <Button type="button" size="sm" variant="gold" onClick={handleCopy}>
            <Copy className="h-3 w-3" />
            {copied ? 'Kopyalandı' : 'Kopyala'}
          </Button>
        </div>
      </div>
      <p className="flex items-start gap-1 break-all text-xs text-muted-foreground">
        <Link2 className="mt-0.5 h-3 w-3 shrink-0" />
        {getInviteUrl(code)}
      </p>
      {error && <p className="mt-2 text-xs text-destructive">{error}</p>}
    </div>
  );
}
